import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mq, spacing, color } from 'core/theme'
import PageLabel from './PageLabel'
import PageLink from './PageLink'
import { PageContextValue } from 'core/types'
import ChevronRight from 'core/icons/ChevronRight'
import ChevronLeft from 'core/icons/ChevronLeft'

const StyledLink = styled(PageLink)`
    color: ${color('primary100')} !important;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: ${props => (props.type === 'previous' ? 'flex-start' : 'flex-end')};
    padding: ${spacing()};

    @media ${mq.smallMedium} {
        padding: 0 16px;
        span {
            display: block;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 100%;
            text-align: center;
        }
    }
`

const PaginationLink = ({
    page,
    type,
    className = ''
}: {
    page: PageContextValue
    type: string
    className: string
}) => (
    <StyledLink
        page={page}
        className={`small-medium pagination__link pagination__${type} ${className}`}
        type={type}
    >
        {type === 'previous' && (
            <LinkContainer>
                <ChevronLeft size="small" />
                <PageLabel page={page} />
            </LinkContainer>
        )}
        {type === 'next' && (
            <LinkContainer>
                <PageLabel page={page} />
                <ChevronRight size="small" />
            </LinkContainer>
        )}
    </StyledLink>
)

PaginationLink.propTypes = {
    page: PropTypes.shape({
        id: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired
    }).isRequired,
    type: PropTypes.oneOf(['previous', 'next']).isRequired
}
const LinkContainer = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    svg {
        path {
            stroke: ${color('primary100')};
        }
    }
`

export default PaginationLink
